<div class="restore-dialog" role="alertdialog" aria-live="assertive">
  <h2 class="restore-dialog__title">Restore Database from DACPAC</h2>

  <div class="restore-dialog__preview">
    <div class="restore-dialog__detail"><strong>Server:</strong> {{ preview.serverName }}</div>
    <div class="restore-dialog__detail"><strong>Database:</strong> {{ preview.databaseName }}</div>
    <div class="restore-dialog__detail"><strong>Dacpac Version:</strong> {{ preview.dacpacVersion || 'Unknown' }}</div>
    <div class="restore-dialog__detail"><strong>Dacpac Size:</strong> {{ preview.dacpacSizeMB?.toFixed(2) || 'Unknown' }} MB</div>
  </div>

  <div class="restore-dialog__warning">
    This is a destructive operation that cannot be undone.
  </div>
  <div class="restore-dialog__warning restore-dialog__warning--danger" *ngIf="!allowRestoreScoring">
    Dacpac file not found. Restoring scoring databases is disabled.
  </div>

  <div class="restore-dialog__options">
    <label class="restore-dialog__checkbox">
      <input
        type="checkbox"
        [checked]="restoreScoring()"
        [disabled]="!allowRestoreScoring"
        (change)="onRestoreScoringToggle($any($event.target).checked)"
      />
      <span>
        <strong>Restore Scoring Databases</strong>
        <small>Drop and redeploy vNext and Messaging databases from dacpac files</small>
      </span>
    </label>

    <label class="restore-dialog__checkbox">
      <input
        type="checkbox"
        [checked]="clearSimulator()"
        [disabled]="restoreScoring()"
        (change)="clearSimulator.set($any($event.target).checked)"
      />
      <span>
        <strong>Clear Simulator Data</strong>
        <small>Remove all simulation definitions and execution history</small>
      </span>
    </label>
  </div>

  <div class="restore-dialog__actions">
    <button
      type="button"
      class="btn btn-white"
      (click)="onCancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-danger"
      [disabled]="!canConfirm()"
      (click)="onConfirm()">
      Yes, Restore
    </button>
  </div>
</div>
